<template>
  <footer v-if="campaign">
    <template v-if="!campaign.footer_content">
      <div class="boxes">
        <b-col md="10" lg="8" class="index-content">
          <b-navbar class="menu-o">
            <b-container>
              <b-navbar-nav v-if="isSessionActiveAndReady && !isMainMenu">
                <b-link @click="goHome()" class="footer_btn_color"><font-awesome-icon :icon="['fas', 'home']" class="footer_btn"></font-awesome-icon> MAIN MENU</b-link>
              </b-navbar-nav>
              <b-navbar-nav v-if="canLogoutSession" class="ml-auto">
                <router-link to="/logout" class="footer_btn_color"><font-awesome-icon :icon="['fas', 'sign-out-alt']" class="footer_btn"></font-awesome-icon>LOG OUT</router-link>
              </b-navbar-nav>
            </b-container>
          </b-navbar>
        </b-col>
      </div>
      <div class="carbon-poweredby"><img :src="require('@/assets/images/powered-by.png')" alt="Powered By SolvPath"></div>
    </template>
    <div v-else-if="campaign && campaign.footer_content" v-html="campaign.footer_content"></div>
  </footer>
</template>
<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Footer',
  computed: {
    ...mapState(['session', 'isLoading', 'campaign']),
    ...mapGetters(['canLogoutSession', 'isSessionActiveAndReady', 'isMainMenu'])
  },
  methods: {
    goHome: function() {
      this.$store.commit('busy')
      this.$store.dispatch('home')
        .then(session => {
          if (this.$router.history.current.meta.requireRedirectForHome) {
            this.$router.replace({name: 'session'}) // If on faq details move to main page
          } else {
            this.$router.go(0) // refresh
          }
        })
    }
  }
}
</script>

<style scoped>

</style>
